import React, { useMemo } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { CategoryItem, fetchCategory, fetchOrderTypes } from '../../api';
import { Checkbox, Table } from 'antd';

const CategoryField = () => {
  const { data: categories } = useSuspenseQuery({
    queryKey: ['menuCategory'],
    queryFn: () => fetchCategory().then(({ data }) => data),
  });
  const { data: orderTypes } = useSuspenseQuery({
    queryKey: ['orderTypes'],
    queryFn: () => fetchOrderTypes().then(({ data }) => data.orderTypes),
  });

  const columns = useMemo(
    () => [
      {
        dataIndex: 'name',
        title: 'Kategori',
      },
      ...orderTypes.map(({ id, orderType }) => {
        return {
          title: orderType,
          render: (_: any, col: CategoryItem) => {
            return <Checkbox value={`${col.id}_${id}`} />;
          },
        };
      }),
    ],
    [orderTypes, categories]
  );

  const tableData: CategoryItem[] = useMemo(() => {
    return [
      ...categories,
      {
        id: '',
        name: 'Custom',
      },
    ];
  }, [categories]);

  return <Table columns={columns} dataSource={tableData} pagination={false} />;
};

export default CategoryField;
